import Users from '@pages/Users.vue';

export default [
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: {
      permissions: [
        {
          role: 'Guest',
          access: false,
          redirect: 'Home',
        },
        {
          role: 'Member',
          access: false,
          redirect: 'Dashboard',
        },
      ],
    },
  },
];
